import { createBrowserRouter } from 'react-router';
import { AppShell } from './components/AppShell';
import { LoadingBoundary } from './components/LoadingBoundary';

const lazyRoute = (loader: () => Promise<{ default: React.ComponentType }>) => ({
  lazy: async () => {
    const mod = await loader();
    return { Component: mod.default };
  },
});

export const router = createBrowserRouter([
  // Outside the shell: both are reachable without a session, and the shell
  // calls /admin/me, which would bounce straight back to /login.
  { path: '/login', ...lazyRoute(() => import('./routes/login')) },
  { path: '/auth/callback', ...lazyRoute(() => import('./routes/auth-callback')) },
  {
    path: '/',
    Component: AppShell,
    errorElement: (
      <div className="main">
        <LoadingBoundary isLoading={false} error={new Error('Route failed to load')}>{null}</LoadingBoundary>
      </div>
    ),
    children: [
      { index: true, ...lazyRoute(() => import('./routes/index')) },

      { path: 'events', ...lazyRoute(() => import('./routes/events/list')) },
      { path: 'events/new', ...lazyRoute(() => import('./routes/events/new')) },
      { path: 'events/:id', ...lazyRoute(() => import('./routes/events/edit')) },
      { path: 'events/:id/door', ...lazyRoute(() => import('./routes/events/door')) },

      { path: 'members', ...lazyRoute(() => import('./routes/members/list')) },
      { path: 'members/:id', ...lazyRoute(() => import('./routes/members/detail')) },

      { path: 'businesses', ...lazyRoute(() => import('./routes/businesses/list')) },
      { path: 'businesses/:id', ...lazyRoute(() => import('./routes/businesses/edit')) },
      { path: 'business-categories', ...lazyRoute(() => import('./routes/business-categories')) },

      { path: 'resources', ...lazyRoute(() => import('./routes/resources')) },

      { path: 'orders', ...lazyRoute(() => import('./routes/orders/list')) },
      { path: 'orders/:reference', ...lazyRoute(() => import('./routes/orders/detail')) },

      { path: 'venues', ...lazyRoute(() => import('./routes/venues/list')) },
      { path: 'venues/new', ...lazyRoute(() => import('./routes/venues/new')) },
      { path: 'venues/:id', ...lazyRoute(() => import('./routes/venues/edit')) },

      { path: 'regions', ...lazyRoute(() => import('./routes/regions/list')) },
      { path: 'regions/new', ...lazyRoute(() => import('./routes/regions/new')) },
      { path: 'regions/:id', ...lazyRoute(() => import('./routes/regions/edit')) },

      { path: 'subscribers', ...lazyRoute(() => import('./routes/subscribers/list')) },
      { path: 'subscribers/new', ...lazyRoute(() => import('./routes/subscribers/new')) },

      { path: 'newsletter', ...lazyRoute(() => import('./routes/newsletter/list')) },
      { path: 'newsletter/new', ...lazyRoute(() => import('./routes/newsletter/new')) },
      { path: 'newsletter/:id', ...lazyRoute(() => import('./routes/newsletter/edit')) },
      { path: 'newsletter/:id/preview', ...lazyRoute(() => import('./routes/newsletter/preview')) },

      { path: 'publish', ...lazyRoute(() => import('./routes/publish')) },
      { path: 'outbox', ...lazyRoute(() => import('./routes/outbox')) },
      { path: 'audit', ...lazyRoute(() => import('./routes/audit')) },
    ],
  },
]);
